module.exports = __webpack_public_path__ + "static/media/dtj-mockup-2.a2b20829.jpg";